import { captureException } from "@sentry/react";
import { useConnection } from "@solana/wallet-adapter-react";
import type { IsolatedVaultPositionMap } from "@stepfinance/lending";
import { HedgeLendingFetcher } from "@stepfinance/lending";
import { useEffect, useMemo, useState } from "react";

import { useMarkets } from "../../contexts/market";
import { useRefreshContext } from "../../contexts/refresh";
import { getTokenByMint } from "../../utils/tokenInfo";
import { useConnectedWallet } from "../wallet";

export const useHedgeLending = () => {
  const { connection } = useConnection();
  const wallet = useConnectedWallet();
  const { refreshID } = useRefreshContext();
  const { marketsInitialised } = useMarkets();
  const [isolatedVaultPositions, setIsolatedVaultPositions] = useState<IsolatedVaultPositionMap>({});

  const hedgeLendingFetcher = useMemo(
    () => wallet && new HedgeLendingFetcher({ connection, wallet, getTokenByMint }),
    [connection, wallet],
  );

  useEffect(() => {
    if (hedgeLendingFetcher && marketsInitialised) {
      void hedgeLendingFetcher
        .fetchUserVaults()
        .then((positions) => positions && setIsolatedVaultPositions(positions))
        .catch((error) => {
          console.error("Hedge Lending Error:", error);
          captureException(error);
        });
    }
  }, [hedgeLendingFetcher, marketsInitialised, refreshID]);

  return { collateral: {}, yieldFarms: {}, isolatedVaults: isolatedVaultPositions };
};
